// extracted by mini-css-extract-plugin
export default {"burger":"styles_burger__WXFt8","burger_line":"styles_burger_line__1JTNA","active":"styles_active__TmdCP"};